import React, { useEffect, useState } from "react";
import {
  Avatar,
  Typography,
  Box,
  IconButton,
  Paper,
  Grid,
  Button,
} from "@mui/material";
import TableN from "../../reusableComponents/components/generics/TableN";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchGuardian,
  fetchLatestActiveInsureePolicy,
  fetchPoliciesByInsuree,
  fetchVerificationHistory,
  insureeVerificationHf,
  printCareSheet,
} from "../../action";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/system";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";
import { decodeId, formatDateFromISO } from "../../utils/helper";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import ReplayIcon from "@mui/icons-material/Replay";
import Tooltip from "@mui/material/Tooltip";
import { clearCareSheetData } from "../../store/actions/exampleAction";
import ParaClinicalVerificationDialog from "../dialog/ParaClinicalVerificationDialog";
import CommonSnackbar from '../../reusableComponents/components/generics/CommonSnackbar';
import { useConvention } from "../../hooks/useConvention";
const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

const StyledRightsTypography = styled(Grid)(({ theme }) => ({
  display: "flex",
  marginTop: "-4.2rem",
  paddingLeft: ".9rem",
}));

const StyledTypography = styled(Typography)(({ theme, isVerified }) => ({
  color: isVerified ? theme.palette.success.main : theme.palette.error.main,
}));

function VerificationPage({ insureeData }) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [guardianChfd, setIsGuardianChfd] = useState(null);
  const [rightsEnable, setRightsEnable] = useState(false);
  const [verifyStatus, setVerifyStatus] = useState(false);
  const [matchingInsuree, setMatchingInsuree] = useState(false);
  const [verificationWithoutBiometry, setVerificationWithoutBiometry] = useState(false);
  const [showParaVerificationDialog, setShowParaVerificationDialog] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");

  const { isConventionnementActive } = useConvention()

  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const fosaDetails = useSelector((state) => state?.fosaReducer);
  const hfid = useSelector(
    (state) =>
      state?.profileReducer?.currentUserResponseData?.i_user?.health_facility_id
  );

  useEffect(() => {
    const category =
      SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.category;
    if (category) {
      setVerificationWithoutBiometry(category.verificationWithoutBiometry);
    }
  }, [SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.category]);


  useEffect(() => {
    const insureeId = insureeData?.camuNumber
      ? insureeData?.camuNumber
      : insureeData?.chfId;
    if (insureeId && hfid) {
      dispatch(fetchVerificationHistory(insureeId,hfid));
      dispatch(fetchPoliciesByInsuree(insureeData?.chfId));
      dispatch(fetchLatestActiveInsureePolicy(insureeData?.chfId));
    }
    if (insureeData?.age < 8) {
      dispatch(fetchGuardian(insureeId));
    }
  }, [insureeData?.chfId, verifyStatus, hfid]);

  useEffect(() => {
    const contentType = "pdf";
    if (fosaDetails?.careSheetData) {
      displayPrintWindow(fosaDetails?.careSheetData?.data, contentType);
    }
    return () => {
      dispatch(clearCareSheetData());
    };
  }, [fosaDetails?.careSheetData]);

  const handleRowsPerPageChange = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleNavigation = (direction) => {
    console.log("Navigating", direction);
  };

  const handleReload = () => {
    setVerifyStatus(true);
    setRightsEnable(false);
  };

  const headers = () => {
    var h = [
      t("verificationNo"),
      t("verifiedBy"),
      t("fosaName"),
      t("createdDate"),
      t("createdTime"),
      t("verificationStatus"),
      t("Action"),
    ];
    return h;
  };

  const openParaVerificationDialog = () => {
    console.log("==>", !showParaVerificationDialog);
    setShowParaVerificationDialog(!showParaVerificationDialog);
  };

  const displayPrintWindow = (base64Data, contentType) => {
    const printWindow = window.open(
      "",
      "Print Window",
      "width=600, height=400"
    );
    printWindow.document.open();
    if (contentType === "pdf") {
      printWindow.document.write(
        `<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,${base64Data}" />`
      );
    } else {
      printWindow.document.write(
        `<img src="data:image/png;base64,${base64Data}" />`
      );
    }
    printWindow.document.close();
  };

  const printRowCamuSheet = async (edited) => {
    const data = await dispatch(printCareSheet(edited));
    const base64Data = data?.payload?.data?.camuCareSheet?.data;
  };

  const verificationHistoryData = fosaDetails?.verificationHistoryData;

  const itemFormatters = () => {
    let f = [
      (verificationHistory) => verificationHistory.verificationCode,
      (verificationHistory) =>
        verificationHistory?.userHf &&
        `${
          !!verificationHistory?.userHf?.verifiedBy
            ? verificationHistory?.userHf?.verifiedBy?.otherNames
            : ""
        }-${
          !!verificationHistory?.userHf?.verifiedBy
            ? verificationHistory?.userHf?.verifiedBy?.chfId
            : ""
        }`,
      (verificationHistory) =>
        verificationHistory?.userHf &&
        verificationHistory?.userHf?.healthFacility &&
        verificationHistory?.userHf?.healthFacility?.name,
      (verificationHistory) =>
        formatDateFromISO(verificationHistory.createdTime),
      (verificationHistory) =>
        moment(verificationHistory.createdTime).format("HH:mm:ss"),
      (verificationHistory) => (
        <StyledTypography isVerified={verificationHistory.isVerified}>
          {!!verificationHistory.isVerified ? t("success") : t("failed")}
        </StyledTypography>
      ),
    ];

    f.push((verificationHistory) =>
      !!verificationHistory.isVerified ? (
        <IconButton onClick={(e) => printRowCamuSheet(verificationHistory)}>
          <LocalPrintshopOutlinedIcon color="primary" />
        </IconButton>
      ) : null
    );

    return f;
  };

  const policiesData = fosaDetails?.policies;

  const policiesHeaders = () => {
    var h = [
      t("productCode"),
      t("productName"),
      t("expiryDate"),
      t("Status"),
      t("deduction"),
      t("hospitalDeduction"),
      t("nonHospitalDeduction"),
      t("ceiling"),
      t("hospitalCeiling"),
      t("nonHospitalCeiling"),
    ];

    return h;
  };

  const policiesItemFormatters = () => {
    let f = [
      (i) => i.productCode,
      (i) => i.productName,
      (i) => formatDateFromISO(i.expiryDate),
      (i) => i.status,
      (i) => i.ded,
      (i) => i.dedInPatient,
      (i) => i.dedOutPatient,
      (i) => i.ceiling,
      (i) => i.ceilingInPatient,
      (i) => i.ceilingOutPatient,
    ];
    return f;
  };

  let ws;
  useEffect(() => {
    if (!!ws && !rightsEnable) {
      ws.close();
      setRightsEnable(false);
    }
  }, [rightsEnable]);

  const handleVerification = async () => {
    console.log("=====> normal handleVerification")
    const guardianFull = guardianChfd ? fosaDetails?.guardianData.find(guardian => guardian.chfId === guardianChfd) : null
    console.log("=====> guardianFull", guardianFull)
    const hfVerificationApi = await dispatch(
      insureeVerificationHf(insureeData?.id, hfid, guardianFull)
    );
    const hfverifiedData = hfVerificationApi?.insureeVerificationHf;

    console.log("=====> normal hfVerificationApi", hfVerificationApi?.insureeVerificationHf)

    if (!rightsEnable && !!hfVerificationApi?.insureeVerificationHf?.success) {
      const host = window.location.host;
      ws = new WebSocket(
        `wss://${
          host.includes("localhost") ? "dev-camu.devopsdemo.live" : host
        }/api/insuree/matching-results/${insureeData?.chfId}/${decodeId(
          !!hfverifiedData?.data.id ? hfverifiedData?.data.id : ""
        )}`
      );

      ws.onopen = () => {
        console.log("connectedweb");
      };

      ws.onmessage = (evt) => {
        const message = JSON.parse(evt.data);
        setMatchingInsuree(message);
        console.log("message", message);
      };

      ws.onclose = () => {
        console.log("disconnected");
      };

      window.open(
        `${process.env.REACT_APP_ABIS_VERIFICATION_URL}?externalId=${
          !!guardianChfd ? guardianChfd : insureeData?.chfId
        }`,
        "_blank"
      );
      setRightsEnable(true);
      setVerifyStatus(false);
    }
  };

  const handleGuardianPickerChange = (e) => {
    setIsGuardianChfd(e.target.value);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  }

  const guardianSelected = guardianChfd || insureeData?.age >= 8

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" mb={2}>
        {/* <IconButton
          color="inherit"
          onClick={() => {
            setMatchingInsuree({});
            setRightsEnable(false);
          }}
        >
          <CloseIcon />
        </IconButton> */}
      </Box>
      <Box display="flex" alignItems="center" mb={3}>
        <Avatar
          alt="User Avatar"
          src={insureeData?.photoUrl}
          sx={{ width: 100, height: 100 }}
        />
        <Box ml={2}>
          <Typography variant="h6">
            {insureeData?.camuNumber
              ? insureeData?.camuNumber
              : insureeData?.chfId}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {insureeData?.otherNames} {insureeData?.lastName}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {insureeData?.dob} ({insureeData?.age} {t("Years")})
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {insureeData?.gender?.code === "M" ? t("Male") : t("Female")}
          </Typography>
        </Box>
        <StyledRightsTypography>
          {!!fosaDetails?.policyValidData && (
            <>
              {fosaDetails?.policyValidData?.policy  ? (
                <Typography color="primary">
                  <CheckCircleIcon color="primary" />
                  {t("rightsEnabled")}
                </Typography>
              ) : (
                <Typography color="red">
                  <CancelIcon color="red" />
                  {t("rightsDisabled")}
                </Typography>
              )}
            </>
          )}
        </StyledRightsTypography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        {insureeData?.age < 8 && !!fosaDetails?.policyValidData && (
          <>
              <Dropdown
                onChange={(e) => {
                  handleGuardianPickerChange(e);
                }}
                options={fosaDetails?.guardianData ? fosaDetails.guardianData.map(guardian => ({
                  value: guardian.chfId,
                  label: `${guardian.lastName} ${guardian.otherNames}`
                }))  : []}
                value={guardianChfd || {}}
              />
          </>
        )}
        {!!rightsEnable && (
          <Tooltip title={t("reloadVerification")}>
            <ReplayIcon
              sx={{ marginRight: "1rem", cursor: "pointer", color: "green" }}
              onClick={() => handleReload()}
            />
          </Tooltip>
        )}
        {verificationWithoutBiometry ? (
          <Button
            variant="contained"
            color="success"
            onClick={openParaVerificationDialog}
            width={4}
            disabled={
              fosaDetails?.policyValidData?.policy &&
              isConventionnementActive &&
              guardianSelected && 
              !rightsEnable
                ? false
                : true
            }
          >
            {t("Verify")}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleVerification()}
            width={4}
            disabled={
              fosaDetails?.policyValidData?.policy &&
              isConventionnementActive &&
              guardianSelected &&
              !rightsEnable
                ? false
                : true
            }
          >
            {t("VerifyFingerprints")}
          </Button>
        )}
      </Box>
      <Box mb={2}>
        <StyledPaper>
          <StyledPaperHeader container alignItems="center" direction="row">
            <Grid item alignItems="center">
              <Typography variant="h6">{t("rights")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <TableN
            headers={policiesHeaders()}
            itemFormatters={policiesItemFormatters()}
            items={policiesData ? policiesData : []}
            withSelection="single"
            withPagination
            rowsPerPageOptions={[10, 50, 100]}
            defaultPageSize={5}
            page={page}
            pageSize={pageSize}
            onChangePage={(event, newPage) => {
              setPage(newPage);
              handleNavigation(newPage > page ? "forward" : "backward");
            }}
            onChangeRowsPerPage={handleRowsPerPageChange}
          />
        </StyledPaper>
      </Box>
      <Box>
        <StyledPaper>
          <StyledPaperHeader container alignItems="center" direction="row">
            <Grid item alignItems="center">
              <Typography variant="h6">{t("verificationHistory")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <TableN
            headers={headers()}
            itemFormatters={itemFormatters()}
            items={verificationHistoryData}
            withSelection="single"
            withPagination
            rowsPerPageOptions={[10, 50, 100]}
            defaultPageSize={5}
            page={page}
            pageSize={pageSize}
            count={0}
            onChangePage={(event, newPage) => {
              setPage(newPage);
              handleNavigation(newPage > page ? "forward" : "backward");
            }}
            onChangeRowsPerPage={handleRowsPerPageChange}
          />
        </StyledPaper>
      </Box>
      {showParaVerificationDialog && (
        <ParaClinicalVerificationDialog
          showDialog={showParaVerificationDialog}
          setShowDialog={setShowParaVerificationDialog}
          insureeId={insureeData ? decodeId(insureeData.id) : null} 
          hfId={hfid}
          setOpenSnackbar={setOpenSnackbar}
          setSnackbarMessage={setSnackbarMessage}
          setSeverity={setSeverity}
        />
      )}
      <CommonSnackbar 
        open={openSnackbar}
        message={snackbarMessage}
        severity={severity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
}

export default VerificationPage;
